import { InputField } from './InputField';
import { OutputField } from './OutputField';
import React, { useMemo } from 'react';
import { getValidationSchemaForFields } from '../../../util';
import { ExpandableCard } from '../ExpandableCard/ExpandableCard';

function useMainDataForRequest(fields, fieldsData, request) {
    return useMemo(() => {
        if (!fields) return {};
        const dataSchema = getValidationSchemaForFields(fields, request && request.nominationParams);
        const dataValues = fields.reduce(
            (obj, field) => ({
                ...obj,
                [field.code || field.id]: (fieldsData[field.id] && fieldsData[field.id].value) || '',
            }),
            {}
        );
        const dataErrors = dataSchema.validate(dataValues);
        return {
            dataSchema,
            dataValues,
            dataErrors,
        };
    }, [fields, fieldsData, request]);
}

/**
 * Убирает из списка полей поля транскрипций, если в исходном поле нет латинских букв.
 *
 * @param {*} origFields массив полей взятых из структуры nomination
 * @param {*} values маппа ключ-значение, где ключ - код поля, значение - значение поля
 * @returns возвращает массив отфильтрованных полей
 */
function useFormFields(origFields, values) {
    return useMemo(() => {
        const fields = [];
        origFields.forEach((field) => {
            if (/Trans$/.test(field.code)) {
                const srcFieldCode = field.code.substring(0, field.code.length - 5);
                const srcFieldValue = values[srcFieldCode];
                //console.log(field, values[field.code], srcFieldCode, srcFieldValue);
                if (values[field.code] || /[A-Za-z]/.test(srcFieldValue)) {
                    fields.push(field);
                }
            } else {
                fields.push(field);
            }
        });
        return fields;
    }, [origFields, values]);
}

export function FormBlock({
    title,
    fields,
    fieldsData,
    executing,
    errors,
    clearErrors,
    readOnly,
    editDataField,
    onCancel,
    onSubmit,
    onEdit,
    children,
    id,
    request,
}) {
    const { dataValues, dataErrors } = useMainDataForRequest(fields, fieldsData, request);
    const filteredFields = useFormFields(fields, dataValues);

    return (
        <ExpandableCard title={title} id={id} defaultExpanded={true}>
            {children}
            {filteredFields.map((field) =>
                editDataField === field.id ? (
                    <InputField
                        key={field.id}
                        field={field}
                        defaultValue={dataValues[field.code || field.id] || ''}
                        onCancel={onCancel}
                        onSubmit={onSubmit}
                        submitting={executing}
                        errors={errors}
                        clearErrors={clearErrors}
                    />
                ) : (
                    <OutputField
                        key={field.id}
                        field={field}
                        value={dataValues[field.code || field.id] || ''}
                        onEditClick={readOnly ? undefined : onEdit}
                        errors={dataErrors}
                    />
                )
            )}
        </ExpandableCard>
    );
}
